export const helpOptions = [
  {
    label: 'Propiedades del Gas LP',
    list: [
      'Incoloro. Incoloro (Cuando se produce se le agrega una sustancia llamada Mercaptano para detectarlo cuando existe fuga). No es tóxico)',
    ] 
  },
  {
    label: '¿Que hacer en caso de fuga?',
    list: [
      'Cierra el paso del regulador y las hornillas de la cocina',
      'Ventila el lugar (Abra puertas y ventanas para que se ventile el lugar)',
      'No encender las luces o algun interruptor',
      'Abandona el lugar',
      'Conserve la calma, no encienda cerillos o algun artefacto que pudiera generar chispa',
      'Desaloje a todas las personas cercanas al lugar',
      'Llame a las autoridades correspondientes marcando al 911',
      'No entre a su hogar hasta que las autoridades o personal capacitado le indiquen que no hay peligro',
      'Haga revisar sus instalaciones inmediatamente por personal calificado y efectué las reparaciones convenientes',
    ]
  },
  {
    label: '¿Por qué medios puedo realizar mi pedido?',
    list: [
      'Llamando a nuestro Contact Center, via whatsapp, desde nuestra app o en nuestra página web',
    ]
  },
  {
    label: 'Mi tanque duró mucho menos de lo habitual',
    list: [
      '¡Te ayudamos! Regálanos una llamada, recuerda tener a la mano al menos tus últimos 3 tickets de carga incluyendo el ticket de la carga actual, con estos datos podremos observar el comportamiento y revisar si existe alguna incosistencia en el consumo',
    ]
  },
  {
    label: '¿Cómo es el metodo de pago?',
    list: [
      'Efectivo / Tarjeta Débito o Crédito / Transferencia',
    ]
  },
  {
    label: '¿Cómo puedo generar mi factura?',
    list: [
      'Desde nuestra pagina web www.globalgas.mx/facturacion/',
      'Asegurate de llenar todos los campos para que podamos enviarte tu factura',
    ]
  },
  {
    label: 'Solicité servicio y aun no ha llegado',
    list: [
      'Puedes revisar nuestra app el status de tu pedido o bien comunicarte con alguno de nuestros agentes y con gusto ellos te apoyarán a ubicar la unidad que te surtirá',
    ]
  },
  {
    label: '¿Entregan nota de compra?',
    list: [
      '¡Si! Siempre deberán entregarle su nota impresa, en dado caso que no se la entreguen puede realizar su reporte al Contact Center de su localidad',
    ]
  },
  {
    label: '¿Cómo puedo saber si ya se esta acabando el gas de mi cilindro?',
    list: [
      'Puede validarlo cuando la flama está baja y torna un color rojizo, eso le indica que esta por terminarse su gas',
    ]
  },
  {
    label: '¿Pueden enviarme la pipa para mi automóvil de carburación o rellenar mi cilindro?',
    list: [
      'Nos gustaria apoyarte pero por motivos de seguridad y norma oficial, debe acudir directamente a una de nuestras estaciones de carburación',
    ]
  },
  {
    label: '¿Cómo sé si mi tanque estacionario ya debe de ser cambiado?',
    list: [
      'El tanque estacionario tiene fecha de fabricación y su tiempo de vida es de 10 años',
    ]
  },
  {
    label: '¿Los repartidores cuentan con terminal para pagar con tarjeta?',
    list: [
      'La mayoria de nuestras unidades cuentan con terminal, puede validar con su agente de Contact Center o bien realizar el pago directamente con su tarjeta en nuestra App Global Gas',
    ]
  },
  {
    label: '¿Cuentan con Asesoría Técnica?',
    list: [
      'Si se cuenta con el servicio técnico y es totalmente gratuito. Ponte en contacto con uno de nuestros agentes del Contact Center y con gusto te ayudarán',
    ]
  },
  {
    label: '¿Cuál es el precio por litro / kilo',
    list: [
      'El precio es variable y depende de la ciudad y de la zona en la que te encuentres, puedes consultarlo entrando a nuestra app o bien llamando al Contact Center de tu localidad',
    ]
  },
]